export const CONTROL_TASK_STATUS_LABELS: Record<string, string> = {
  OPEN: 'Открыта',
  OVERDUE: 'Просрочена',
  DONE: 'Выполнена',
  CANCELLED: 'Не требуется',
};

/** Canonical active control tasks (CP-010C / CP-010D). */
export const ACTIVE_CONTROL_TASK_STATUSES = [
  'OPEN',
  'OVERDUE',
  'IN_PROGRESS',
  'PENDING',
] as const;

export const HISTORY_CONTROL_TASK_STATUSES = ['DONE', 'CANCELLED'] as const;

export function isActiveControlTaskStatus(status: string | null | undefined): boolean {
  const normalized = String(status || '').trim().toUpperCase();
  return (ACTIVE_CONTROL_TASK_STATUSES as readonly string[]).includes(normalized);
}

export function isHistoryControlTaskStatus(status: string | null | undefined): boolean {
  const normalized = String(status || '').trim().toUpperCase();
  return (HISTORY_CONTROL_TASK_STATUSES as readonly string[]).includes(normalized);
}

